module.exports = __webpack_public_path__ + "static/media/mash-busd.b034280b.png";